import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { fetchAdminDashboardSummary } from "../api/api";

function formatCurrency(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount || 0);
}

function AdminDashboard() {

  const navigate = useNavigate();

  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function load() {
      setLoading(true);
      setError("");
      try {
        const data = await fetchAdminDashboardSummary();
        setSummary(data);
      } catch (err) {
        setError("Could not load dashboard stats. Please refresh.");
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div className="admin-content">

        <h1>
          Dashboard
        </h1>

        {error && <p className="login-error" style={{ color: "red" }}>{error}</p>}

        {/* STATS */}

        <div className="stats-grid">

          <div className="stats-card" style={{ cursor: "pointer" }} onClick={() => navigate("/plots")}>
            <h3>Total Plots</h3>
            <h1>{loading ? "…" : summary?.total_plots ?? 0}</h1>
          </div>

          <div className="stats-card" style={{ cursor: "pointer" }} onClick={() => navigate("/plots?due=this-month")}>
            <h3>Maintenance Due This Month</h3>
            <h1 style={{ color: "red" }}>
              {loading ? "…" : summary?.maintenance_due_this_month_count ?? 0}
            </h1>
          </div>

          <div className="stats-card">
            <h3>Maintenance Amount Collected (YTD)</h3>
            <h1>
              {loading ? "…" : formatCurrency(summary?.maintenance_amount_collected_ytd)}
            </h1>
          </div>

          <div className="stats-card">
            <h3>Water Charges Collected (YTD)</h3>
            <h1>
              {loading ? "…" : formatCurrency(summary?.water_charges_amount_collected_ytd)}
            </h1>
          </div>

          <div className="stats-card">
            <h3>Other Charges Collected (YTD)</h3>
            <h1>
              {loading ? "…" : formatCurrency(summary?.other_amount_collected_ytd)}
            </h1>
          </div>

          <div className="stats-card" style={{ cursor: "pointer" }} onClick={() => navigate("/customers")}>
            <h3>Customers</h3>
            <h1>{loading ? "…" : summary?.customers_count ?? 0}</h1>
          </div>

          <div className="stats-card" style={{ cursor: "pointer" }} onClick={() => navigate("/issues")}>
            <h3>Customer Issues</h3>
            <h1 style={{ color: "orange" }}>
              {loading ? "…" : summary?.open_issues_count ?? 0}
            </h1>
          </div>

          {/* Open NoC Requests card hidden per request — re-enable by
              uncommenting; /noc route and the summary field are untouched.
          <div className="stats-card" style={{ cursor: "pointer" }} onClick={() => navigate("/noc")}>
            <h3>Open NoC Requests</h3>
            <h1 style={{ color: "orange" }}>
              {loading ? "…" : summary?.open_noc_requests_count ?? 0}
            </h1>
          </div>
          */}

          <div className="stats-card" style={{ cursor: "pointer" }} onClick={() => navigate("/admin-referrals")}>
            <h3>Referrals</h3>
            <h1>
              {loading ? "…" : summary?.total_referrals_count ?? 0}
            </h1>
            <p style={{ margin: 0, color: "#666" }}>
              {loading ? "" : `${summary?.pending_referrals_count ?? 0} awaiting follow-up`}
            </p>
          </div>

        </div>

      </div>

    </div>

  );

}

export default AdminDashboard;
